enum ERequestState {
  'LOADING' = 'loading',
  'ERROR' = 'error',
  'SUCCESS' = 'success',
}

export default ERequestState;
